export default {"src":"/_next/static/media/Hungary.bab51cf1.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};